// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!
/* tslint:disable */
export const APP_VERSION = '0.6.0';
export const APP_NAME = 'children-monitor';
export const FILE_HASH = '1583233299620';
export const BUILD_DATE = '2020-03-03T11:01:39.620Z';
/* tslint:enable */
